export function useSurfaceEditorStoreDataResources() {
  const fonts = ref(null);
  const colorGroups = ref(null);

  async function getFonts() {
    if (!fonts.value) {
      const res = await useSurfaceEditorCmsApi().getGoogleFonts();
      fonts.value = res.map(f => f.name);
      useGoogleFonts().loadFonts(fonts.value);
    }

    return fonts.value;
  }

  async function getColors() {
    if (!colorGroups.value) {
      const cmsColors = await useSurfaceEditorCmsApi().getColors();
      colorGroups.value = cmsColors.reduce((grouped, color) => {
        const colorTypeKey = Object.keys(SURFACE_EDITOR_COLOR_TYPES)
          .find(typeKey => SURFACE_EDITOR_COLOR_TYPES[typeKey].key === color.type);

        if (SURFACE_EDITOR_COLOR_TYPES[colorTypeKey]) {
          grouped[color.type] = grouped[color.type] || {
            ...SURFACE_EDITOR_COLOR_TYPES[colorTypeKey],
            colors: []
          };
          grouped[color.type].colors.push({
            id: color.id,
            type: color.type,
            color: color.solid,
            angle: color.gradientAngle,
            stops: color.gradientStops,
            url: color.patternImg,
            btnUrl: color.patternBtnImg
          })
        }

        return grouped;
      }, {});
    }

    return colorGroups.value;
  }

  return {
    fonts,
    getFonts,
    colorGroups,
    getColors
  };
}
